import Component from '../inherited/Component'
import AjaxApi from '../lib/AjaxApi'

export default class AddToCart extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._options = {...{
      redirect: null,
      addingText: 'Adding...',
      addedText: null,
      waitFor: 1500,
      openSideCart: true
    }, ...this._options}
    this._variantIdElem = this._elem.querySelector('[name="id"]')
    this._variantSkuElem = this._elem.querySelector('[data-variant-sku]')
    this._sellingPlanIdElems = this._elem.querySelectorAll('[name="selling_plan"]')

    this._quantityElem = this._elem.querySelector('[name="quantity"]')
    this._submitElems = this._elem.nodeName === 'FORM' ? this._elem.querySelectorAll('[type="submit"]') : [this._elem]
    this._propertyElems = this._elem.querySelectorAll('[name^="properties"]')
  }

  mount () {
    this._addListeners()
  }

  _getProperties () {
    this._propertyElems = this._elem.querySelectorAll('[name^="properties"]')
    let properties = {}
    let propElems = Array.from(this._propertyElems).filter(elem => !elem.hasAttribute('disabled') && elem.value.length > 0)
    for (let elem of propElems) {
      properties[elem.getAttribute('name').match(/^properties\[(.+)\]$/)[1]] = elem.value
    }

    if (propElems.length === 0 && this._elem.dataset.properties) {
      properties = JSON.parse(this._elem.dataset.properties)
    }

    return properties
  }

  _addListeners () {
    let event = null
    if (this._elem.nodeName === 'FORM') {
      event = 'submit'
    } else {
      event = 'click'
    } 
    this._elem.addEventListener(event, async e => {
      e.preventDefault()
      //let originalText = this._submitElem.innerHTML
      //this._submitElem.innerHTML = this._options.addingText
      for (let elem of this._submitElems) {
        elem.classList.add('ffc--adding-to-cart')
      }

      if (this._options.addedText) {
        for (let elem of this._submitElems) {
          elem.style.minWidth = `${elem.getBoundingClientRect().width}px`
        }
      }

      let variantId = this._variantIdElem ? this._variantIdElem.value : this._elem.dataset.variantId
      let variantSku = this._variantSkuElem?.textContent
      let quantity = this._quantityElem ? Number(this._quantityElem.value) : Number(this._elem.dataset.quantity)
      let selling_plan = this._elem.dataset.sellingPlan || ''

      if (this._sellingPlanIdElems) {
        for (let elem of this._sellingPlanIdElems) {
          if (elem.checked) {
            selling_plan = elem.value
          }
        }
      }

      let properties = this._getProperties()


      if(this._options.sparkLayer && window.spark && variantSku) {
        let sparkObject = {
          products: [
              {
                  sku: variantSku,
                  adjustQuantity: quantity
              },
          ],
          clearCart: false
        }
        await window.spark.updateCart(sparkObject)

        for (let elem of this._submitElems) {
          elem.classList.remove('ffc--adding-to-cart')
          elem.classList.add('ffc--added-to-cart')
        }

      } else {

        let items = [
          {
            id: variantId,
            quantity: quantity,
            properties: properties,
            selling_plan: selling_plan
          }
        ]
        
        try {
          let data = await AjaxApi.addToCart({
            items: items
          })

          let matchingItem = data.items.find(item => variantId === `${item.variant_id}`)

          try {
            gtag('event', 'add_to_cart', {
              currency: window.Shopify.currency.active,
              value: matchingItem.price / 100.00,
              items: [
                {
                  item_name: matchingItem.product_title,
                  item_id: matchingItem.sku,
                  item_variant: matchingItem.variant_title
                }
              ]
            })
          } catch (e) {
            console.error(e)
          }

        } catch (e) {
          console.error("ERROR")
          console.error(e.response.data)
          alert(e.response.data.description)
        }

        this._ctx.emit('cart-item-added', {
          lastItemAdded: {
            item: items[0],
            quantity: items[0].quantity,
            properties: items[0].properties
          }
        })
      
        if (this._options.openSideCart) {
          this._ctx.emit('show-side-cart')
        }

        if (!this._options.redirect) {
          for (let elem of this._submitElems) {
            elem.classList.remove('ffc--adding-to-cart')
            elem.classList.add('ffc--added-to-cart')
          }

          if (this._options.addedText) {
            for (let elem of this._submitElems) {
              elem.innerHTML = this._options.addedText
            }
          }
          
          setTimeout(() => {
            //this._submitElem.innerHTML = originalText
            for (let elem of this._submitElems) {
              elem.classList.remove('ffc--added-to-cart')
            }
          }, this._options.waitFor)
        }

        if (this._options.redirect) {
          window.location = this._options.redirect
        }

      }
    })
  }
}
